import { bool, func, number, oneOf, oneOfType, string } from "prop-types";
import { createContext, useRef, useState } from "react";

import styled from "styled-components";

import { addOntypes } from "Giving/constants";

import FnrAccordion from "UI/FnrAccordion";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";
import useIsWiderThan from "Utilities/Hooks/useIsWiderThan";

import AccordionContents from "./AccordionContents";
import AccordionLabel from "./AccordionLabel";

const EditorContext = createContext();
const SDiv = styled("div")`
  flex-grow: 1;
`;

const Editor = ({
  title,
  fundName,
  description,
  amount,
  icon,
  isRequired,
  isEditable,
  deleteGift,
  percentage,
  type,
  addOnGiftID,
}) => {
  const containerRef = useRef();

  const horizontal = useIsWiderThan(containerRef, { px: 320 });
  const isHoverFocused = useIsHoverFocused(containerRef);
  const [active, setActive] = useState(false);

  return (
    <EditorContext.Provider
      value={{
        percentage,
        type,
        fundName,
        description,
        isEditable,
        amount,
        deleteGift,
        active,
        setActive,
        title,
        icon,
        isRequired,
        isHoverFocused,
        horizontal,
        addOnGiftID,
      }}
    >
      <FnrHorizontalGap topAlign gap={0} ref={containerRef}>
        <SDiv>
          <FnrAccordion
            setActive={setActive}
            active={active}
            fullWidth
            defaultClosed
            noActiveMargin
            addCard
            label={<AccordionLabel />}
            highlightAll
            chevronStyle="none"
            hoverBackgroundColor="fnBlueGrey"
          >
            <AccordionContents />
          </FnrAccordion>
        </SDiv>
      </FnrHorizontalGap>
    </EditorContext.Provider>
  );
};

Editor.propTypes = {
  addOnGiftID: number.isRequired,
  amount: oneOfType([number, string]),
  fundName: string,
  description: string,
  title: string,
  icon: string,
  percentage: oneOfType([string, number]),
  isRequired: bool,
  isEditable: bool,
  type: oneOf([
    addOntypes.AMOUNT,
    addOntypes.COVER_THE_FEES,
    addOntypes.PERCENTAGE,
  ]),
  deleteGift: func.isRequired,
};

export { EditorContext };
export default Editor;
